// power by topgrowth
import { Link } from "react-router-dom"

export default function Footer() {
    return (
        <footer className="bg-gray-900 text-gray-400 py-8">
            <div className="container mx-auto px-4 text-center">
                <div className="flex flex-col items-center justify-center space-y-4">
                    <Link href="/" className="flex items-center space-x-2">
                        <img
                            src="/darshan logo.png"
                            alt="GameZone"
                            className="w-28"
                        />
                        <span className="font-bold text-white pl-5">Sprint 2025</span>
                    </Link>
                    <p className="text-sm">
                        All rights reserved by &nbsp;
                        <a href="https://topgrowth.in" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700">
                            topgrowth.in
                        </a>
                        &nbsp; © {new Date().getFullYear()}
                    </p>
                </div>
            </div>
        </footer>
    )
}